module.exports = __webpack_public_path__ + "img/gpr_banner.c9a1d0c1.png";